
namespace TabAurous.Common {

  
    @Serenity.Decorators.registerClass()
    export class POSOrderItemsForStockAllocation extends _Ext.GridBase<Retail.POSOrderItemsRow, any> {
        protected getColumnsKey() { return 'Retail.OrderItems'; }
        protected getDialogType() { return Retail.POSOrderItemsDialog; }
        protected getIdProperty() { return Retail.POSOrderItemsRow.idProperty; }
        protected getInsertPermission() { return Retail.POSOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return Retail.POSOrderItemsRow.localTextPrefix; }
        protected getService() { return Retail.POSOrderForStockAllocationService.baseUrl; }

        private autoSize; 
        withBom: boolean;
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): Retail.POSOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //private getEffectiveValue(item, field): any {
        //    var pending = this.pendingChanges[item.ProductID];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }

        //    return item[field];
        //}

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}